export const IMAGES = {
  hero: "/images/hero-cyclope.webp",
  engineering: "/images/tiso-bollards-blocker.webp",
};

export const BRANDS = [
  {
    name: "TiSO",
    origin: "Global",
    logo: "/brands/tiso-dark.png",
    tagline: "High-security bollards, shallow road blockers & tyre killers",
    blurb: "One of the world's deepest certified HVM catalogues — fixed, automatic and removable bollards, Cyclope shallow blockers and hydraulic tyre killers tested to ISO 22343, PAS 68 and ASTM F2656.",
    lines: "500+ configurations",
  },
  {
    name: "Automatic Systems",
    origin: "Belgium",
    logo: "/brands/automatic-systems-dark.png",
    tagline: "Anti-terrorist beam barriers & high-security rising fences",
    blurb: "The BL M50 vertical-lift beam barrier stops a 7.5t truck at 80 km/h — certified to PAS 68, IWA 14-1 and ASTM M50 with 2.0 MJ impact resistance across 3–6 m clear openings.",
    lines: "BL & BLG series",
  },
  {
    name: "AccessX Fencing",
    origin: "",
    logo: "/accessx-logo-white.png",
    tagline: "Crash-rated palisade fencing",
    blurb: "Our crash-rated palisade fencing line — validated to ISO 22343-1:2023 and ASTM F2656 — for long perimeters, crowded places and critical infrastructure.",
    lines: "Crash-rated palisade fencing",
  },
  {
    name: "HySecurity | Nice",
    origin: "USA",
    logo: "/brands/hysecurity-nice.png",
    tagline: "StrongArm crash-rated barrier arms & HydraWedge SM50",
    blurb: "ASTM F2656 M30/M50 crash-rated StrongArm barrier arms for 12–24 ft openings, and the HydraWedge SM50 — a zero-penetration wedge barrier certified to ASTM, IWA 14-1 and PAS 68.",
    lines: "StrongArm, HydraWedge + StrongSlide",
  },
  {
    name: "ARX Security",
    origin: "UK",
    logo: "/brands/arx.png",
    tagline: "ARX STOPPER! mobile surface-mounted HVM",
    blurb: "The pedestrian-permeable mobile barrier: steel units linked by wire rope in a slalom array stop a 7.5t truck at 48 km/h — certified to PAS 68 and IWA 14-1. No foundations, deploys in minutes, packs into a single stillage.",
    lines: "ARX STOPPER! system",
  },
  {
    name: "LBA Group",
    origin: "France",
    logo: "/brands/lba.png",
    tagline: "Crash-tested static bollards, car stoppers & manual swing barriers",
    blurb: "Made in France by LBA Group: cost-effective static bollards rated from 1.5 t car-stopper duty to a physically tested 7.2 t @ 48 km/h, in standard or shallow-mount (≈180 mm) versions — plus MSB manual swing barriers that stop a 7.2 t truck at 80 km/h on a 6 m opening with no power supply.",
    lines: "F-series bollards + MSB barriers",
  },
];

export const PRODUCTS = [
  { name: "C750 Fixed Bollard RB 345-09-S", brand: "TiSO", category: "bollards", rating: "PAS 68 • ISO 22343 • IWA 14-1", foundation: "Deep foundation", span: "≈1.2 m centres", bestFor: "High-security fixed perimeters", brochure: "/brochures/tiso-c750-fixed-bollard-rb345.pdf" },
  { name: "Fixed Bollard 273-09-S", brand: "TiSO", category: "bollards", rating: "ISO 22343 V/7200[N2A]/80/90", foundation: "500 mm", span: "≈1.2 m centres", bestFor: "Certified protection over shallow utilities", brochure: "/brochures/tiso-rb273-09-s-fixed-bollards.pdf" },
  { name: "M30/M50 Automatic Bollards RB 348 / 342", brand: "TiSO", category: "bollards", rating: "M30–M50 class", foundation: "Deep foundation", span: "≈1.2 m centres", bestFor: "Controlled vehicle access points", brochure: "/brochures/tiso-m50-automatic-bollards.pdf" },
  { name: "F25-60-1548 Car Stopper Bollard", brand: "LBA Group", category: "bollards", rating: "Car stopper — 1.5 t @ 48 km/h (ISO 22343-1 simulation, 3-bollard group)", foundation: "410 mm • shallow TFP version ≈180 mm", span: "H 600 mm • Ø 250 mm", bestFor: "Storefronts, footpaths & car parks — stopping cars, not trucks", brochure: "/brochures/lba-f25-60-1548-car-stopper-bollard.pdf", drawing: "/brochures/lba-f25-60-1548-tfp-installation-drawing.pdf" },
  { name: "F25-60-3548 Car Stopper Bollard", brand: "LBA Group", category: "bollards", rating: "Car stopper — 3.5 t @ 48 km/h (ISO 22343-1 simulation, 3-bollard group)", foundation: "410 mm • shallow TFP version ≈180 mm", span: "H 600 mm • Ø 250 mm", bestFor: "Vans & light trucks at retail, campus & civic frontages", brochure: "/brochures/lba-f25-60-3548-car-stopper-bollard.pdf", drawing: "/brochures/lba-f25-60-3548-tfp-installation-drawing.pdf" },
  { name: "F16-100-C50 Crash-Tested Bollard", brand: "LBA Group", category: "bollards", rating: "Crash tested (Transpolis) 3.5 t @ 50 km/h, 3 bollards at 1.36 m centres • 7.5 t @ 48 km/h digital", foundation: "650 mm", span: "H 1,000 mm • Ø 160 mm • 1.36 m centres", bestFor: "Slim, physically tested bollard for streetscapes & plazas", brochure: "/brochures/lba-f16-100-c50-bollard.pdf" },
  { name: "F25-100-7548 Static Security Bollard", brand: "LBA Group", category: "bollards", rating: "ISO 22343-1 physical test — 7.2 t @ 48 km/h, 0.4 m penetration", foundation: "490 mm ground beam", span: "H 1,000 mm • Ø 250 mm", bestFor: "Real 7.2 t truck-rated protection with a compact foundation", brochure: "/brochures/lba-f25-100-7548-bollard.pdf" },
  { name: "Cyclope Shallow Road Blocker RB 33X", brand: "TiSO", category: "blockers", rating: "ISO 22343 • ASTM F2656 M50", foundation: "600 mm shallow", span: "2–6 m spans", bestFor: "Wide entries above buried services", brochure: "/brochures/tiso-rb33x-shallow-blocker.pdf" },
  { name: "Ultra-Shallow Blocker RB 33X-01", brand: "TiSO", category: "blockers", rating: "PAS 68 • IWA 14-1 — 7.5t @ 80 km/h", foundation: "200 mm ultra-shallow", span: "2–6 m spans", bestFor: "Retrofits where excavation is limited", brochure: "/brochures/tiso-rb33x-01-ultra-shallow.pdf" },
  { name: "HydraWedge SM50", brand: "HySecurity | Nice", category: "blockers", rating: "ASTM M50-P1 • IWA 14-1 :0.0 • PAS 68 :0.0", foundation: "Shallow, road-integrated", span: "Up to 4 m", bestFor: "Zero-penetration entries, 3-second cycle", brochure: "/brochures/hysecurity-hydrawedge-sm50.pdf" },
  { name: "BL M50 Vertical Lift Beam Barrier", brand: "Automatic Systems", category: "barriers", rating: "PAS 68 • IWA 14-1 • ASTM M50 • 2.0 MJ", foundation: "Pit / surface", span: "3–6 m clear", bestFor: "High-security gate lines", brochure: "/brochures/automatic-systems-high-security-portfolio.pdf" },
  { name: "StrongArm M30", brand: "HySecurity | Nice", category: "barriers", rating: "ASTM F2656 M30-P1", foundation: "Surface mount", span: "12–24 ft clear", bestFor: "Commercial & industrial gates", brochure: "/brochures/hysecurity-strongarm-m30-m50.pdf" },
  { name: "StrongArm M50", brand: "HySecurity | Nice", category: "barriers", rating: "ASTM F2656 M50-P2", foundation: "Surface mount", span: "12–24 ft clear", bestFor: "Embassies, ports & utilities", brochure: "/brochures/hysecurity-strongarm-m30-m50.pdf" },
  { name: "MSB-C50 Manual Swing Barrier", brand: "LBA Group", category: "barriers", rating: "Crash tested (Transpolis, shallow-mount) — 7.5 t @ 49 km/h on a 6 m opening, 1.0 m penetration", foundation: "Two 1 × 1 × 1 m pits • shallow-mount FP version < 500 mm", span: "2–6 m clear, one unit per opening", bestFor: "Unpowered secure entries — manual 180° swing, padlockable", brochure: "/brochures/lba-msb-c50-manual-barrier.pdf" },
  { name: "MSB-C80 Manual Swing Barrier", brand: "LBA Group", category: "barriers", rating: "IWA 14-1 V/7200[N2A]/80/90:2.4 • ASTM F2656 U50-P2 — 7.2 t @ 80 km/h on a 6 m opening", foundation: "Two 1.5 × 1.5 × 1.2 m pits • shallow-mount FP version < 500 mm", span: "2–10 m clear (braced from 7 m)", bestFor: "High-speed approaches where no power is available", brochure: "/brochures/lba-msb-c80-manual-barrier.pdf" },
  { name: "BLG 76 / 77 Rising Fenced Barriers", brand: "Automatic Systems", category: "barriers", rating: "High-security deterrent", foundation: "Surface", span: "Up to 6 m", bestFor: "Intensive-use secure perimeters", brochure: "/brochures/automatic-systems-blg7x.pdf" },
  { name: "BL43 C50 High-Impact Barrier Arm", brand: "Automatic Systems", category: "barriers", rating: "IWA 14-1 — M1 1,500 kg @ 65 km/h", foundation: "Surface mount", span: "Lane width", bestFor: "High-security sites with limited space & ground clearance", brochure: "/brochures/automatic-systems-bl43c50.pdf" },
  { name: "Crash-Rated Palisade Fencing", brand: "AccessX Fencing", category: "fencing", rating: "ISO 22343-1:2023 • ASTM F2656", foundation: "Continuous footings", span: "Continuous run", bestFor: "Long perimeters, crowded places & critical infrastructure", brochure: "/brochures/doomax-vrf.pdf" },
  { name: "Mobile Road Blockers RB 357 / RB 358", brand: "TiSO", category: "mobile", rating: "M30 class, rapid deploy", foundation: "None — surface deploy", span: "Modular spans", bestFor: "Events & temporary perimeters", brochure: "/brochures/tiso-rb357-mobile.pdf" },
  { name: "Tyre Killers RB 370 / RB 379", brand: "TiSO", category: "mobile", rating: "Lane denial", foundation: "Surface / shallow", span: "Lane width", bestFor: "Wrong-way & tailgate control", brochure: "/brochures/tiso-automatic-tire-killer.pdf" },
  { name: "ARX STOPPER! Mobile HVM Array", brand: "ARX Security", category: "mobile", rating: "PAS 68 • IWA 14-1 — 7.5t @ 48 km/h", foundation: "None — surface mount", span: "6.5 m per 7-unit array", bestFor: "Events, crowded places & rapid deployment", brochure: "/brochures/accessx-arx-stopper-brochure.pdf" },
  { name: "StrongSlide M30 Crash-Rated Slide Gate", brand: "HySecurity | Nice", category: "gates", rating: "ASTM F2656-20 M30-P1", foundation: "Concrete pad, bolted structures", span: "Up to 24 ft (7.3 m) clear", bestFor: "Crash-rated sliding gate entries", brochure: "/brochures/hysecurity-strongslide-m30.pdf" },
];

export const productAnchor = (name) => `product-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

export const CATEGORIES = [
  { id: "all", label: "Full range" },
  { id: "bollards", label: "Bollards" },
  { id: "blockers", label: "Blockers & Wedges" },
  { id: "barriers", label: "Barriers & Arms" },
  { id: "gates", label: "Gates" },
  { id: "fencing", label: "Rated Fencing" },
  { id: "mobile", label: "Mobile & Tyre" },
];

export const CERTS = [
  {
    code: "ISO 22343-1",
    year: "2023",
    status: "current",
    title: "The current global benchmark",
    body: "Introduced September 2023, ISO 22343 is now the international standard for vehicle security barriers — officially replacing PAS 68 and IWA 14-1. The reference point for new specifications across Oceania.",
    example: "V/7200[N2A]/80/90:2.5/30.8",
    guide: "/blog/iso-22343-guide",
  },
  {
    code: "BSI PAS 68",
    year: "2013",
    status: "superseded",
    title: "Replaced by ISO 22343",
    body: "The pioneering UK crash-test standard — officially replaced by ISO 22343. Still cited across thousands of existing specifications, and certificates earned under PAS 68 remain valid evidence of performance.",
    example: "V/7500(N3)/80/90:0.0/0.0",
    guide: "/blog/pas-68-guide",
  },
  {
    code: "IWA 14-1",
    year: "2013",
    status: "superseded",
    title: "Replaced by ISO 22343",
    body: "ISO's interim international agreement bridged PAS 68 and US test methods — now replaced by ISO 22343, which carries forward its vehicle classes (N3C rigid truck) and test discipline.",
    example: "V/7200[N3C]/80/90:0.0",
    guide: "/blog/iwa-14-1-guide",
  },
  {
    code: "ASTM F2656",
    year: "US",
    status: "current",
    title: "The American standard — current",
    body: "The US State Department lineage: M30 / M40 / M50 speed classes (30–50 mph for a 6.8t truck) with P1–P4 penetration ratings. Still the active US standard — common on US-engineered products like HySecurity StrongArm and HydraWedge.",
    example: "M50-P1 (6.8t @ 80 km/h, <1 m)",
    guide: "/blog/astm-f2656-guide",
  },
];

export const DECODER_SEGMENTS = [
  { token: "V", label: "Test method", desc: "Vehicle impact test — a real, instrumented crash test with an actual vehicle. Not a simulation, not a calculation." },
  { token: "7200", label: "Vehicle mass", desc: "7,200 kg — the mass of the test vehicle at impact, a fully laden rigid truck." },
  { token: "[N3C]", label: "Vehicle class", desc: "N3C — a heavy goods vehicle category, the standard hostile-vehicle threat used across ISO 22343 and IWA 14-1." },
  { token: "80", label: "Impact speed", desc: "80 km/h at the moment of impact — the kinetic energy the barrier must absorb." },
  { token: "90", label: "Impact angle", desc: "90° — a head-on, perpendicular attack. The worst case, and the rating basis." },
  { token: "1.5", label: "Penetration", desc: "1.5 m — how far the vehicle's load bed travelled past the barrier line. Zero-penetration options exist." },
  { token: "0.0", label: "Debris dispersion", desc: "0.0 m — no major debris scattered beyond 25 m. Critical for crowded places and pedestrian zones." },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Hostile is not accidental",
    body: "An accidental impact is a driver losing control at 30 km/h. A hostile attack is a 7.2-tonne truck aimed at your crowd at 80. Different physics, different standards, different products. We help you scope the real threat so you don't over-spend — or under-protect.",
  },
  {
    num: "02",
    title: "Certified, not estimated",
    body: "Every rating we quote comes from an instrumented physical crash test with a published report. Many products on the market are merely 'engineered to resist' — calculated, not proven. With engineers and specifiers, we only trade in certified performance.",
  },
  {
    num: "03",
    title: "One size fits no one",
    body: "Foundation depth, span, duty cycle, aesthetics, excavation limits — every site is different. That's why we carry 70+ product lines from five leading brands: TiSO, Automatic Systems, AccessX Fencing, HySecurity | Nice and ARX Security. If a single product range could solve it, we'd only sell one.",
  },
  {
    num: "04",
    title: "Specified, not sold",
    body: "HVM doesn't belong in a shopping cart. Every project starts with a scoping conversation — site type, run length, threat level, standard required — so the barrier you sign off is the barrier your risk assessment actually demands.",
  },
];

export const MARQUEE_ITEMS = [
  "ISO 22343-1", "BSI PAS 68", "IWA 14-1", "ASTM F2656", "M50-P1 ZERO PENETRATION",
  "70+ PRODUCT LINES", "5 GLOBAL BRANDS", "NZ + AU INSTALLATION", "CERTIFIED CRASH TESTS",
];

export const CASE_STUDIES = [
  {
    id: "airport",
    image: "/images/airport-blocker-1.webp",
    images: ["/images/airport-blocker-1.webp", "/images/airport-blocker-2.webp", "/images/airport-blocker-3.webp"],
    tag: "Airports & Aviation",
    title: "International airport — airside vehicle access",
    detail: "Three TiSO RB333-01 ultra-shallow road blockers — just 200 mm foundation depth — supplied for a New Zealand international airport.",
    stat: "3 × RB333-01",
    client: "International airport (NZ)",
    location: "New Zealand",
    products: "3 × TiSO RB333-01 ultra-shallow road blockers (200 mm foundation)",
    rating: "BSI PAS 68:2013 • IWA 14-1:2013 — 7.5 t @ 80 km/h",
    body: "Airside vehicle gates demand certified stopping power without tearing up congested ground. We supplied three TiSO RB333-01 ultra-shallow road blockers — certified to BSI PAS 68:2013 and IWA 14-1:2013, stopping a 7.5-tonne truck at 80 km/h with a foundation depth of only 200 mm — fully integrated into the airport's access control.",
  },
  {
    id: "dia",
    image: "/images/dia-bollards-1.webp",
    images: ["/images/dia-bollards-1.webp", "/images/dia-bollards-2.webp"],
    tag: "Government",
    title: "DIA — PAS 68 HVM bollards",
    detail: "Multiple PAS 68-rated HVM bollards installed to stop a 7,200 kg truck at 48 km/h at a DIA facility.",
    stat: "7,200 kg @ 48 km/h",
    client: "DIA (NZ Government)",
    location: "New Zealand",
    products: "PAS 68 HVM rising bollards",
    rating: "PAS 68 — 7,200 kg @ 48 km/h",
    body: "A government facility required certified hostile vehicle protection on a service access lane. We supplied multiple PAS 68-rated rising bollards — certified to stop a 7,200 kg truck at 48 km/h — installed by our certified partner network and flush-finished to keep the lane clear for daily operations.",
  },
  {
    id: "bl43",
    image: "/images/bl43-barrier-1.webp",
    images: ["/images/bl43-barrier-1.webp", "/images/bl43-barrier-2.webp", "/images/bl43-barrier-3.webp"],
    tag: "High-Security Site",
    title: "Automatic Systems BL43 C50 — tight-footprint protection",
    detail: "Limited space and ground clearance ruled out blockers — the BL43 C50 high-impact barrier arm delivered certified protection.",
    stat: "1,500 kg @ 65 km/h",
    client: "High-security facility (confidential)",
    location: "New Zealand",
    products: "Automatic Systems BL43 C50 high-impact barrier arm",
    rating: "IWA 14-1 — M1 vehicle, 1,500 kg @ 65 km/h",
    body: "This high-security site had limited space and almost no ground clearance, ruling out road blockers and deep-foundation bollards. We specified the Automatic Systems BL43 C50 high-impact barrier arm — IWA 14-1 certified against a 1,500 kg M1 vehicle at 65 km/h — surface-mounted within the existing entry footprint.",
  },
];

export const SECTORS = [
  "Stadiums & Events", "Government & Defence", "Ports & Airports",
  "Civic & Public Realm", "Corrections", "Data Centres", "Commercial & Retail",
];

export const SITE_TYPES = [
  "Government / Council", "Stadium & Events", "Airport & Ports",
  "Commercial & Retail", "Crowded Place / Public Realm", "Industrial & Logistics", "Other",
];

export const STANDARDS_OPTIONS = [
  "ISO 22343", "PAS 68", "IWA 14-1", "ASTM F2656", "Not sure — need advice",
];

export const TIMELINES = [
  "Urgent (< 1 month)", "1–3 months", "3–6 months", "Planning / spec stage",
];
